import ErrorId from './errorId'

const ErrorMessage = {
  getMessage: function (errorId) {
    switch (errorId) {
      //------------------------ Group ---------------------
      case ErrorId.Group__PermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.Group__NotFound:
        return '群組不存在，請確認系統上有此群組'

      //------------------------ Device ---------------------
      case ErrorId.Device__NoDevice:
        return '設備不存在，請確認系統上有此設備'
      case ErrorId.Device__PermissionNotAllow:
        return '操作權限不足，請管理員提供該設備的權限'
      case ErrorId.Device__SendCommandFail:
        return '指令發送失敗，請確定設備已經註冊並上線'
      case ErrorId.Device__NoIrControl:
        return 'Device__NoIrControl'
      case ErrorId.Device__NoIrControlKey:
        return 'Device__NoIrControlKey'
      case ErrorId.Device__UpdateDataFail:
        return '更新要求發送失敗，請確定設備已經註冊並上線'
      case ErrorId.Device__DeviceExist:
        return '設備已經存在系統上，請檢查是否已經註冊過或設備ID輸入錯誤'
      case ErrorId.Device__NoUserId:
        return 'Device__NoUserId'
      case ErrorId.Device__GwNotFound:
        return 'Device__GwNotFound'
      case ErrorId.Device__ActiveCodeError:
        return 'Device__ActiveCodeError'
      case ErrorId.Device__TooManySubDvice:
        return 'Device__TooManySubDvice'
      case ErrorId.Device__NoDeviceModel:
        return '設備類型不存在，請確認系統上有此設備類型'
      case ErrorId.Device__CommandCached:
        return 'Device__CommandCached'

      //------------------------ Trigger Action ---------------------
      case ErrorId.TriggerAction__NoTrigger:
        return '查無此觸發程序ID，請確認存在此觸發程序'
      case ErrorId.TriggerAction__AddFaild:
        return '新增觸發程序錯誤，請檢查是否輸入資料有誤'
      case ErrorId.TriggerAction__UpdateFaild:
        return '修改觸發程序錯誤，請檢查是否輸入資料有誤'
      case ErrorId.TriggerAction__PermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.TriggerAction__DeleleFaild:
        return '刪除trigger失敗'

      //------------------------ Script Service ---------------------
      case ErrorId.Script__NoScript:
        return '查無此預儲程序ID，請確認存在此預儲程序'
      case ErrorId.Script__PermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.Script__TooManyRequest:
        return '過於頻繁呼叫，請稍帶幾分鐘再重試'

      //------------------------ Other ---------------------
      case ErrorId.Other__SystemError:
      case ErrorId.Other__PathError:
      case ErrorId.Other__500Error:
        return '系統錯誤，回報開發工程師'
      case ErrorId.Other__ErrorConfirmCode:
        return '驗證碼錯誤，請檢查是否有輸入錯誤或重新申請驗證碼'
      case ErrorId.JWTToken_Invalid:
        return 'Jwt Token 不合法'
      case ErrorId.Input_Data_Error:
        return '輸入的資料不正確'
      case ErrorId.Device_Exception:
        return 'Device_Exception'
      case ErrorId.Invalid_Time_Range:
        return 'Invalid_Time_Range'
      case ErrorId.Invalid_YearMonth_Format:
        return 'Invalid_YearMonth_Format'

      //------------------------ Community ---------------------
      case ErrorId.CommunityId_NotFound:
        return '社區不存在，請確認系統上有此社區'
      case ErrorId.CommunityNoticeId_NotFound:
        return '社區公告不存在，請確認系統上有此社區公告'
      case ErrorId.CommunityId_Or_BuildingId_Or_FloorId_NotFound:
        return '社區、棟或樓不存在，請確認系統上有此社區、棟或樓'
      case ErrorId.CommunityNoticeId_Update_Failed:
        return '社區公告修改失敗'
      case ErrorId.CommunityNoticeId_Delete_Failed:
        return '社區公告刪除失敗'
      case ErrorId.CommunityNoticeId_Add_Failed:
        return '社區公告加入排程失敗'
      case ErrorId.CommunityNoticeId_Cancel_Failed:
        return '社區公告撤除排程失敗'
      case ErrorId.SipCommunityId_Update_Failed:
        return '通航社區編號修改失敗'
      case ErrorId.SipCommunityId_Duplicate_Entry:
        return '通航社區編號已存在'
      case ErrorId.COMMUNITY_ALREADY_DOWNLOADED:
        return '已經下載過QRcode列表'

      //------------------------ Floor ---------------------
      case ErrorId.Floor_Already_Exist:
        return '樓層已存在'
      case ErrorId.FloorId_NotFound:
        return '樓層不存在，請確認系統上有此樓層'
      case ErrorId.FloorPlan_Update_Fail:
        return 'FloorPlan_Update_Fail'
      case ErrorId.Building_Not_Found:
        return 'Building_Not_Found'

      //------------------------ SIP ---------------------
      case ErrorId.SIP_Number_Exhausted:
        return 'SIP 帳號已達上限'
      case ErrorId.SIP_Register_Failed:
        return 'SIP 註冊失敗'
      case ErrorId.SIP_UnRegister_Failed:
        return 'SIP 解註冊失敗'
      case ErrorId.Binding_count_is_over:
        return 'SIP 註冊已達上限'
      case ErrorId.UnRegister_Failed:
        return 'SIP 解註冊失敗'
      case ErrorId.User_Cancel_Failed:
        return '第一筆SIP無法移除'
      case ErrorId.First_SIP_NotFound_Or_No_User:
        return '找不到第一筆SIP或沒有使用者'
      case ErrorId.PushToken_NotFound:
        return '找不到PushToken'

      //------------------------ Household ---------------------
      case ErrorId.HouseholdId_NotFound:
        return '戶別不存在，請確認系統上有此戶別'
      case ErrorId.Invalid_HouseholdCode:
        return '住戶代碼不合法'
      case ErrorId.Mac_NotFound:
        return '找不到Mac'
      case ErrorId.Household_Create_Failed:
        return '戶別建立失敗'
      case ErrorId.Household_Update_Failed:
        return 'Household_Update_Failed'
      case ErrorId.Mac_Duplicate_Entry:
        return '請確認 Mac 是否重複'
      case ErrorId.HouseholdName_In_Community_Duplicate:
        return '此社區已存在此戶別名稱'

      //------------------------ MailPackage ---------------------
      case ErrorId.MailPackageId_NotFound:
        return '郵件包裹不存在，請確認系統上有此郵件包裹'
      case ErrorId.MailPackage_Pickup_Failed:
        return '郵件包裹領取失敗'
      case ErrorId.MailPackage_Return_Failed:
        return '郵件包裹退貨申請失敗'
      case ErrorId.MailPackage_Create_Barcode_Failed:
        return '手機郵件條碼產生失敗'
      case ErrorId.Invalid_Compression_Input:
        return '輸入的條碼有誤或不存在'

      //------------------------ Schedule ---------------------
      case ErrorId.Add_Schedule_Fail:
        return '加入排程失敗'

      //------------------------ Registration ---------------------
      case ErrorId.Duplicate_Registration:
        return '重複歸戶'
      case ErrorId.Registration_NotFound:
        return '找不到歸戶資訊'

      //------------------------ Gasregistration ---------------------
      case ErrorId.Gas_Registration_YearMonth_Already_Exist:
        return '此年月的瓦斯登記已存在'
      case ErrorId.Gas_Household_Registration_Already_Exist:
        return '此戶別已填過瓦斯登記'
      case ErrorId.Gas_Registration_Delete_Fail:
        return '瓦斯登記刪除失敗'
      case ErrorId.Gas_RegistrationId_NotFound:
        return '瓦斯登記不存在，請確認系統上有此瓦斯登記'
      case ErrorId.Gas_Registration_Update_Fail:
        return '瓦斯登記修改失敗'
      case ErrorId.Gas_Registration_Past_YearMonth_Error:
        return '瓦斯登記的年月不可為過去時間'
      case ErrorId.Gas_Registration_StartTime_Before_Previous_EndTime:
        return '瓦斯登記開始時間不能早於前一期截止日期'
      case ErrorId.Gas_Household_Registration_No_Change_After_DeadLine:
        return '瓦斯戶別登記，表示在截止時間之後不允許新增或刪除操作'
      case ErrorId.Gas_Registration_Unable_To_Update_After_DeadLine:
        return '瓦斯登記已超過截止時間，無法進行修改'
      case ErrorId.Gas_Registration_Not_Allowed_In_The_Same_Month:
        return '無法同時開放兩個登記項目'
      case ErrorId.Pending_Gas_Registration_Filling_Not_Permitted:
        return '待發佈的瓦斯登記不允許填寫'
      case ErrorId.Gas_Filling_Not_Allowed_Before_Start_Date:
        return '開始日期未到的瓦斯登記不允許填寫'
      case ErrorId.Gas_Registration_Add_Failed:
        return 'Gas_Registration_Add_Failed'
      case ErrorId.Gas_Registration_Invalid_Status:
        return 'Gas_Registration_Invalid_Status'

      //------------------------ System ---------------------
      case ErrorId.SUCCESS:
        return '操作成功'
      case ErrorId.System__NoLogin:
        return '無法登入'
      case ErrorId.System__NoMethod:
        return 'App/服務異常，回報開發工程師'
      case ErrorId.System__ErrorPath:
        return 'App/服務異常，回報開發工程師'
      case ErrorId.System__ErrorFormate:
        return 'App/服務異常，回報開發工程師'
      case ErrorId.System__ErrorParameter:
        return 'App/服務異常，回報開發工程師'
      case ErrorId.System__PermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.System__UploadFileError:
        return '檔案上傳失敗，回報開發工程師'
      //------------------------ System ---------------------
      case ErrorId.Login__AccountPasswordError:
        return '帳號/密碼錯誤，請檢查是否輸入錯誤，重新登入'
      case ErrorId.Login__TokenExpire:
        return '認證資料逾期，關閉App，重新登入'
      case ErrorId.Login__TokenReflashFail:
        return '認證資料更新失敗，關閉App，重新登入'
      case ErrorId.Login__AccountDisabled:
        return '帳號已停用，請聯絡管理員'
      case ErrorId.Login__AccountNotActive:
        return '帳號尚未啟用，請聯絡管理員'
      case ErrorId.Login__GroupPermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.Login__AclPermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'

      //------------------------   Create Account ---------------------
      case ErrorId.CreateAccount__AccountExist:
        return '帳號已經存在，請嘗試登入或使用忘記密碼功能重置密碼'

      //------------------------    Account ---------------------
      case ErrorId.Account__PermissionNotAllow:
        return '操作權限不足，請管理員提供該功能的權限'
      case ErrorId.Account__NotFound:
        return '帳號不存在，請確認系統上有此帳號'
      case ErrorId.Account__SendVerifiCodeFrequent:
        return '過於頻繁要求驗證碼，請稍帶幾分鐘再重試'

      //------------------------ CSV ---------------------------
      case ErrorId.ERROR_EXPORTING_CSV:
        return 'CSV匯出失敗'

      //------------------------   other new ---------------------
      case ErrorId.TonnetDoorControl_Device_NotFound:
        return '找不到此社區的門口機設備'
      case ErrorId.Device_ANPR_NotFound:
        return '找不到此社區的車牌辨識設備'
      case ErrorId.Device_MainDoor_AND_Security_Guard_Machine_NotFound:
        return 'Device_MainDoor_AND_Security_Guard_Machine_NotFound'
      case ErrorId.Device_VehicleGate_NotFound:
        return 'Device_VehicleGate_NotFound'
      case ErrorId.Device_VehicleGate_Asid_Or_Key_Error:
        return 'Device_VehicleGate_Asid_Or_Key_Error'
      case ErrorId.Device_VehicleGate_CarAddError:
        return 'Device_VehicleGate_CarAddError'
      case ErrorId.Device_VehicleGate_CarDelError:
        return 'Device_VehicleGate_CarDelError'
      case ErrorId.BuildingId_NotFound:
        return '樓層不存在，請確認系統上有此樓層'
      case ErrorId.Advertisement_NotFound:
        return '廣告不存在，請確認系統上有此廣告'
      case ErrorId.Advertisement_Update_Failed:
        return '廣告修改失敗'
      case ErrorId.Advertisement_Deactivate_Failed:
        return 'Advertisement_Deactivate_Failed'
      case ErrorId.Advertisement_Add_Failed:
        return 'Advertisement_Add_Failed'
      case ErrorId.Account_NotFound:
        return '找不到使用者'
      case ErrorId.V3_Account_NotFound:
        return 'V3_Account_NotFound'

      //------------------------ Vehicle ---------------------
      case ErrorId.Vehicle_Duplicate_Entry:
        return '在此社區下的停車場註冊重複的車牌號碼'
      case ErrorId.Vehicle_Registration_Failed:
        return '車輛註冊失敗'
      case ErrorId.Vehicle_Delete_Failed:
        return '車輛刪除失敗'
      case ErrorId.Vehicle_NotFound:
        return 'Vehicle_NotFound'

      //------------------------ Login ---------------------
      case ErrorId.Unauthorized_Login_SS:
        return '無權限登入SS平台'
      case ErrorId.Unauthorized_Login_Community_WEB:
        return '無權限登入WEB平台'
      case ErrorId.Unauthorized_Login_Community_APP:
        return '無權限登入APP平台'

      //--------------- CFS ------------------
      case ErrorId.Cfs_File_Not_Exist:
        return '檔案不存在'

      //--------------- QRCode ------------------
      case ErrorId.QrcodeExpire_NotFound:
        return '找不到 QRCode 設定'
      case ErrorId.QrcodeExpire_Fetch_Fail:
        return '取得 QRCode 設定失敗'
      case ErrorId.QrcodeExpire_Update_Fail:
        return '更新 QRCode 設定失敗'

      default:
        return '未知錯誤'
    }
  }
}

export default ErrorMessage
